export const SALE_STATUSES = new Set(["paid", "sent", "link_clicked", "shipped", "delivered"]);

export const getOrderItemCount = (order = {}) =>
  Array.isArray(order?.items) ? order.items.length : 0;

export const getOrderTotal = (order = {}) => {
  if (order?.totalAmount !== undefined && order?.totalAmount !== null && order?.totalAmount !== "") {
    const total = Number(order.totalAmount);
    if (Number.isFinite(total) && total >= 0) return total;
  }

  if (!Array.isArray(order?.items)) return 0;

  return order.items.reduce((total, item) => {
    const price = Number(item?.price);
    const quantity = Number(item?.quantity ?? 1);

    if (!Number.isFinite(price) || !Number.isFinite(quantity) || quantity < 0) {
      return total;
    }

    return total + price * quantity;
  }, 0);
};

const startOfDay = (date) => {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  return result;
};

const startOfWeek = (date) => {
  const result = startOfDay(date);
  result.setDate(result.getDate() - result.getDay());
  return result;
};

const startOfMonth = (date) => {
  const result = startOfDay(date);
  result.setDate(1);
  return result;
};

export const calculateProductSales = (orders = [], now = new Date()) => {
  const todayStart = startOfDay(now);
  const weekStart = startOfWeek(now);
  const monthStart = startOfMonth(now);

  return orders.reduce(
    (totals, order) => {
      const status = String(order?.status || "").toLowerCase();
      const createdAt = new Date(order?.createdAt);
      const itemCount = getOrderItemCount(order);

      if (
        !SALE_STATUSES.has(status) ||
        itemCount === 0 ||
        Number.isNaN(createdAt.getTime()) ||
        createdAt > now
      ) {
        return totals;
      }

      if (createdAt >= monthStart) totals.month += itemCount;
      if (createdAt >= weekStart) totals.week += itemCount;
      if (createdAt >= todayStart) totals.today += itemCount;

      return totals;
    },
    { today: 0, week: 0, month: 0 }
  );
};

export const calculateSalesTotals = (orders = [], now = new Date()) => {
  const todayStart = startOfDay(now);
  const weekStart = startOfWeek(now);
  const monthStart = startOfMonth(now);

  return orders.reduce(
    (totals, order) => {
      const status = String(order?.status || "").toLowerCase();
      const createdAt = new Date(order?.createdAt);
      const orderTotal = getOrderTotal(order);

      if (
        !SALE_STATUSES.has(status) ||
        Number.isNaN(createdAt.getTime()) ||
        createdAt > now
      ) {
        return totals;
      }

      if (createdAt >= monthStart) totals.month += orderTotal;
      if (createdAt >= weekStart) totals.week += orderTotal;
      if (createdAt >= todayStart) totals.today += orderTotal;

      return totals;
    },
    { today: 0, week: 0, month: 0 }
  );
};
